/**
 * Classifiable File Extensions
 *
 * Canonical list of file extensions supported by the document/email
 * classification steps. Shared between backend (validation/filtering)
 * and frontend (config UI multi-select).
 *
 * Extensions are stored lowercase without a leading dot.
 */

export interface ClassifiableFileExtension {
  /** Lowercase extension without leading dot (e.g. "xlsx") */
  extension: string;
  /** Human-readable label for UI display */
  label: string;
  /** Grouping for multi-select UI */
  group: "Spreadsheet" | "Document" | "Image";
}

export const CLASSIFIABLE_FILE_EXTENSIONS: readonly ClassifiableFileExtension[] =
  [
    // Spreadsheet
    { extension: "xlsx", label: "Excel (.xlsx)", group: "Spreadsheet" },
    { extension: "csv", label: "CSV (.csv)", group: "Spreadsheet" },

    // Document
    { extension: "pdf", label: "PDF (.pdf)", group: "Document" },

    // Image
    { extension: "png", label: "PNG (.png)", group: "Image" },
    { extension: "jpg", label: "JPEG (.jpg)", group: "Image" },
    { extension: "jpeg", label: "JPEG (.jpeg)", group: "Image" },
  ] as const;

/** Just the extension strings, for Zod schema validation */
export const CLASSIFIABLE_EXTENSIONS: readonly string[] =
  CLASSIFIABLE_FILE_EXTENSIONS.map((f) => f.extension);
